module.exports = __webpack_public_path__ + "10e0bf5410a765adfac06c9a18846018.png";